import { render, staticRenderFns } from "./baseSet.vue?vue&type=template&id=cf4e8694&scoped=true&"
import script from "./baseSet.vue?vue&type=script&lang=js&"
export * from "./baseSet.vue?vue&type=script&lang=js&"
import style0 from "./baseSet.vue?vue&type=style&index=0&id=cf4e8694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4e8694",
  null
  
)

export default component.exports